exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 48rem) {\n    ._1xcn {\n        border: 1px solid var(--ink-water);\n        padding: 2rem;\n        border-radius: 0.5rem;\n        box-shadow: 0 2px 4px rgba(70, 70, 70, 0.05), 0 6px 12px rgba(70, 70, 70, 0.08);\n    }\n}\n", ""]);

// exports
exports.locals = {
	"panel": "_1xcn"
};